import { makeStyles } from "@mui/styles";

const DetailStyle = makeStyles((theme) => ({
  linksButton: {
    "&.MuiButton-root": {
      padding: "10px 15px !important",
      borderRadius: "50px !important",
      boxShadow: " 0 0 15px rgb(0 0 0 / 8%) !important",
      background: "#008374",
      border: "2px solid rgba(255, 255, 255, 0.1) !important",
      letterSpacing: "1px !important",
      fontWeight: "500 !important",
      textTransform: "capitalize !important",
      fontSize: "12px",
      "&:hover": {
        borderColor: "rgba(255, 255, 255, 0.5) !important",
        backgroundColor: "#008374",
      },
    },
  },
}));

export default DetailStyle;
